var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11898_7843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2276 2.11502V11.8296H16.7724V2.11502H1.2276ZM17.181 0.900024C17.6328 0.900024 17.9991 1.26272 17.9991 1.71002V12.2346C17.9991 12.6819 17.6328 13.0446 17.1801 13.0446L9.5031 13.0437V15.885H12.5964C12.9357 15.885 13.2102 16.1577 13.2102 16.4925C13.2098 16.5727 13.1937 16.6521 13.1626 16.726C13.1316 16.8 13.0863 16.8671 13.0293 16.9235C12.9722 16.98 12.9047 17.0246 12.8304 17.0549C12.7561 17.0852 12.6766 17.1005 12.5964 17.1H5.3829C5.30269 17.1005 5.22318 17.0852 5.1489 17.0549C5.07463 17.0246 5.00706 16.98 4.95005 16.9235C4.89304 16.8671 4.84771 16.8 4.81667 16.726C4.78562 16.6521 4.76945 16.5727 4.7691 16.4925C4.7691 16.1577 5.0445 15.8859 5.3829 15.8859L8.2773 15.885V13.0437H0.8181C0.602474 13.0449 0.395191 12.9605 0.241793 12.8089C0.0883944 12.6574 0.00142784 12.4511 0 12.2355L0 1.71002C0 1.26272 0.3663 0.900024 0.819 0.900024H17.181Z",
    fill: "#B9B9B9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11898_7843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.28223c385571bfcf1e9f7233e47a2f78.svg";
export { ForwardRef as ReactComponent };